import i18n from "shared/i18n";
import WAValidator from 'multicoin-address-validator';

const mapping = [
  { name: 'Aave', code: 'aave', validation: true },
  { name: 'Algorand', code: 'algo', validation: true },
  { name: 'Bitcoin', code: 'btc', validation: true },
  { name: 'Bitcoin Cash', code: 'bch', validation: true },
  { name: 'Bitcoin SV', code: 'bsv', validation: true },
  { name: 'Cardano', code: 'ada', validation: true },
  { name: 'Chainlink', code: 'link', validation: true },
  { name: 'Crypto.com Coin', code: 'cro', validation: true },
  { name: 'Dai', code: 'dai', validation: true },
  { name: 'Dogecoin', code: 'doge', validation: true },
  { name: 'EOS', code: 'eos', validation: true },
  { name: 'Ethereum', code: 'eth', validation: true },
  { name: 'Ethereum Classic', code: 'etc', validation: true },
  { name: 'Litecoin', code: 'ltc', validation: true },
  { name: 'Maker', code: 'mkr', validation: true },
  { name: 'Monero', code: 'xmr', validation: true },
  { name: 'Neo', code: 'neo', validation: true },
  { name: 'Polkadot', code: 'dot', validation: true },
  { name: 'Polygon', code: 'matic', validation: true },
  { name: 'Ripple', code: 'xrp', validation: true },
  { name: 'Stellar', code: 'xlm', validation: true },
  { name: 'TRON', code: 'trx', validation: true },
  { name: 'Tether', code: 'usdt', validation: true },
  { name: 'USD Coin', code: 'usdc', validation: true },
  { name: 'Uniswap', code: 'uni', validation: true },
  { name: 'VeChain', code: 'vet', validation: true },

  // No Validation
  { name: 'Amp', code: 'amp', validation: false },
  { name: 'Binance Coin', code: 'bnb', validation: false },
  { name: 'Binance USD', code: 'busd', validation: false },
  { name: 'Bitcoin BEP2', code: 'btcb', validation: false },
  { name: 'FTX Token', code: 'ftt', validation: false },
  { name: 'Filecoin', code: 'fil', validation: false },
  { name: 'Internet Computer', code: 'icp', validation: false },
  { name: 'SHIBA INU', code: 'shib', validation: false },
  { name: 'Solana', code: 'sol', validation: false },
  { name: 'Terra', code: 'luna', validation: false },
  { name: 'Theta', code: 'theta', validation: false },
  { name: 'Theta Fuel', code: 'tfuel', validation: false },
  { name: 'UNUS SED LEO', code: 'leo', validation: false },
  { name: 'Wrapped Bitcoin', code: 'wbtc', validation: false },
];


const validate = (cryptoLinkList, name, value, executedFunction = null) => {
  let errors = null;

  if (!value) {
    return i18n.t("Crypto Adress should not be empty");
  }

  if (value) {
    if (value.length < 3) {
      return i18n.t("Ensure address has more than 3 characters");
    }

    if (value.length > 256) {
      return i18n.t("Ensure address has no more than 256 characters");
    }

    mapping.forEach(item => {
      if (
        name === item.name &&
        item.validation &&
        !WAValidator.validate(value, item.code)
      ) {
        errors = `${i18n.t("Please enter a valid")} ${name} ${i18n.t("address")}`;
      }
    });
  }

  // EXECUTED FUNCTION
  if (!errors && executedFunction) {
    executedFunction();
    return null;
  }

  return errors;

};
export default validate;
